import {Component} from 'substance'
import {mapKeyToSymbol} from '../../../../../lib/utils/mapKeyToSymbol'

const prettify = function(data) {
    return data.split('+').map((key) => mapKeyToSymbol(key, true)).join(' ')
}

class ContentMenuItem extends Component {

    render($$) {
        let listItem = $$('li')
            .attr('data-combo', prettify(this.props.combo))
            .append(this.getLabel(this.props.label))

        if (this.props.active) {
            listItem.addClass('active')
        }

        return listItem
    }

}

export default ContentMenuItem
